import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

import type { PriceVO } from '@ctct/domain-layer';

// define the slice
export interface IPrepaySelectSlice {
  prepay: string;
  prepaySelectDisabled: boolean;
  planBaseMonthlyPrice: null | {
    value: PriceVO;
    currency: string;
  };
}

export const createPrepaySelectSliceDefaultValues = (): IPrepaySelectSlice => ({
  prepay: '12',
  prepaySelectDisabled: false,
  planBaseMonthlyPrice: null,
});

// create the slice helpers
export const createPrepaySelectSlice: StateCreator<IPrepaySelectSlice> = () => createPrepaySelectSliceDefaultValues();

export type PrepaySelectPageStore = UseBoundStore<StoreApi<IPrepaySelectSlice>>;

// create the hooks helpers
export const createPrepaySelectHooks = (pageStore: PrepaySelectPageStore) => {
  return {
    usePrepay: () => pageStore((state) => state.prepay),
    useDisabled: () => pageStore((state) => state.prepaySelectDisabled),
    usePlanBaseMonthlyPrice: () => pageStore((state) => state.planBaseMonthlyPrice),
  };
};

export type PrepaySelectHooks = ReturnType<typeof createPrepaySelectHooks>;
